var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',{staticClass:"my-5"},[_c('b-row',[_c('FormCredenciamento',{staticClass:"mx-auto"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }